import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../../../../../shared/shared.service';
import { AccountService } from '../../accounts.service';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})
export class AccountsComponent implements OnInit {

  dataSource = [];
  sessionId = sessionStorage.getItem('com-session-id');

  constructor(
    private httpClient: HttpClient,
    public sharedService: SharedService,
    public account: AccountService
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    const postThis = {
      SessionID: this.sessionId,
      ID: 'TabAccountSummary'
    };
    this.httpClient.post<any>(`${this.sharedService.URL}/utData`, postThis).subscribe(Response2 => {
      this.dataSource = Response2.utData_response.list;
      this.sharedService.loadingActive = false;
    });
  }

  clickEdit(data) {
    this.account.setAccount(0);
    sessionStorage.setItem('account-id', data);
  }
  clickNew() {
    this.account.setAccount(1);
  }

}
